module.exports = __webpack_public_path__ + "img/hc_sub.38a0dc8f.png";